import axios from "axios";
import { calculateWidths } from './pleated/calculations/calculateWidths.js';
import { calculateCOM } from './pleated/calculations/calculateCOM.js';
//import { calculateRepeatSurcharge } from "./pleated/calculateRepeatSurcharge.js";
import { calculateD1 } from './pleated/calculations/calculateD1.js';
import { calculateCutLength } from './pleated/calculations/calculateCutLength.js';
import { calculateFabricNeededForRepeat } from './pleated/calculations/calculateFabricNeededForRepeat.js';
import { calculateD7 } from './pleated/calculations/calculateD7.js';
import { calculcateTrimming } from './pleated/calculations/calculateTrimming.js';
import { calculatePleat } from './pleated/calculations/calculatePleat.js';
import priceData from './pleated/data/codePricing.json';//assert {type:"json"};
import { calculateD3 } from "./pleated/calculations/calculateD3.js";
import { calculateD11 } from "./pleated/calculations/calculateD11.js";

let cancelToken = null;

const BASE_URL = "/shop/api/v1/promo";
const state = {
    pleated: [],
};

const getters = {
    pleated: state => state.pleated,
};

const actions = {
    loadPleatedGetData({ commit }, id) {
        return axios.post(`${BASE_URL}/pleated-get-data`, {id})
            .then(response => {
                const data = response.data;
                return data;
            });
    },
    masterFunction({ commit },data) {
        console.log("masterFunction() start");
        
        //instantiate return object
        var result = {
                trimming: {
                    vertical: {},
                    horizontal: {},
                    total: {},
                },
                errors: [],
        };

        //Apply Number Fixed for Calculation
        data.finishedLength = Number(data.finishedLength);

        result.finishedWidth =
                data.rodWidth + data.leftReturn + data.rightReturn + data.overlap;

        result.totalWidths = calculateWidths(
                data.fabricWidth,
                data.fullness,
                result.finishedWidth
        );

        result.cutLength = calculateCutLength(data.finishedLength, data.lining);

        result.fabricNeededForRepeat = calculateFabricNeededForRepeat(
                result.cutLength,
                data.repeat
        );

        result.totalLength = result.cutLength + result.fabricNeededForRepeat;

        result.COMyardage = calculateCOM(
                result.totalWidths,
                result.cutLength,
                result.fabricNeededForRepeat
        );

        result.pricePoint = priceData[data.priceCode];

        let D1Total =
                calculateD1(
                    result.pricePoint,
                    data.lining,
                    result.totalWidths,
                    data.finishedLength,
                    data.COM
                ) * 2; //multiple by 2 to get retail price
                
        result.D1 = Math.round(D1Total);
        
        result.D1 = Math.round(D1Total);

        result.pleatCost = calculatePleat(
            data.selectedPleat,
            data.COM,
            result.totalWidths,
            data.pricePoint
        );

        if(data.fabric_type == 'Yes'){
            result.d3Surcharge = calculateD3(
                result.totalWidths,
                data.COM,
            );
        }else{
            result.d3Surcharge = 0;
        }

        result.liningCost = 0;
        if (data.selectedLining ==  "RM Designer Deluxe Cotton Sateen" || data.selectedLining == "RM Designer Deluxe Cotton FR Sateen" || data.selectedLining == "RM Designer Recycled Royal Satin" || data.selectedLining == "RM Designer Napped Sateen") {
            result.liningCost = calculateD11(
                result.totalWidths, 
                data.finishedLength,
                data.selectedLining, 
                data.COM
            );
        }
        
        result.interliningCost = calculateD7(
            result.totalWidths, 
            data.interlining, 
            "",
            data.COM
        );

        result.blackoutguardCost = 0;
        if (data.lining == true && data.blackoutguard == true) {
            result.blackoutguardCost = (result.totalWidths * 40);
        }
        console.log(data.blackoutguard, result.blackoutguardCost);
        result.blackoutCost = 0;
        if(data.selectedLining == 'RM Designer 3 Pass Non-FR Outblack' || data.selectedLining == 'RM Designer Lite Tech Blackout' || data.selectedLining == 'RM Designer Flametrol 3 Pass FR Blackout'){
            result.blackoutCost = calculateD11(
                result.totalWidths, 
                data.finishedLength,
                data.selectedLining, 
                data.COM
            );
        }

        result.trimming = calculcateTrimming(
                data.trimming,
                data.finishedLength,
                data.panelOrPair,
                result.totalWidths,
                data.fabricWidth
        );

        result.unitCost =
            result.D1 + 
            result.trimming.total.cost + 
            result.pleatCost + 
            result.liningCost +
            result.interliningCost + 
            result.blackoutCost +
            result.blackoutguardCost +
            result.d3Surcharge;

        console.log("masterFunction() end");
        console.log(result);
        console.log("-----------------------------END--------------------------");
        return result;
    },
    loadFabricData({ commit }, data) {
        return axios
            .post(`${BASE_URL}/pleated-fabric-data`, data)
            .then(response => {
                const data = response.data;
                return data;
            });
    },
    loadTrimData({ commit }, data) {
        return axios
            .post(`${BASE_URL}/pleated-trim-data`, data)
            .then(response => {
                const data = response.data;
                return data;
            });
    },
    AddPleatedData({ commit }, data) {
        return axios
            .post(`${BASE_URL}/pleated-add-data`, data)
            .then(response => {
             
                const data = response.data;
                return data;
            });
    },
    UpdatePleatedData({ commit }, data) {
        return axios
            .post(`${BASE_URL}/pleated-update-data`, data)
            .then(response => {
             
                const data = response.data;
                return data;
            });
    },

};

const mutations = {
    PLEATED: (state, data) => {
        state.pleated = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
